// reducers
import dashboardReducer from '../modules/dashboard';
import newsReducer from '../modules/news';
import discountsReducer from '../modules/discounts';
import bmAccountsReducer from '../modules/bm-accounts';
import spacesReducer from '../modules/spaces';
import offersReducer from '../modules/offers/list';
import offerReducer from '../modules/offers/single';
import ticketsReducer from '../modules/tickets/list';
import ticketReducer from '../modules/tickets/item';
import financesReducer from '../modules/finances';
import profileReducer from '../modules/profile';
import statisticsReducer from '../modules/statistics/general';
import analyticsReducer from '../modules/statistics/analytics';
import systemAnalyticsReducer from '../modules/statistics/system-analytics';
import unacceptableConversionsReducer from '../modules/statistics/ban';
import conversionsReducer from '../modules/statistics/conversions';
import globalPostbackReducer from '../modules/global-postback';
import ranksReducer from '../modules/ranks';
import streamsReducer from '../modules/streams/list';
import streamReducer from '../modules/streams/single';
import userApiReducer from '../modules/user-api';
import smartNotificationReducer from '../modules/smart-notification';
import affiliatesReducer from '../modules/affiliates';
import managerPopupReducer from './tickets/manager-popup';
import appReducer from '../modules/root';
import chainListReducer from '../modules/statistics/components/offers';
import surveyReducer from './survey';
import managerReducer from './manager';

export default {
	app: appReducer,
	dashboard: dashboardReducer,
	news: newsReducer,
	discounts: discountsReducer,
	spaces: spacesReducer,
	offers: offersReducer,
	offer: offerReducer,
	tickets: ticketsReducer,
	ticket: ticketReducer,
	finances: financesReducer,
	profile: profileReducer,
	statistics: statisticsReducer,
	analytics: analyticsReducer,
	systemAnalytics: systemAnalyticsReducer,
	conversions: conversionsReducer,
	unacceptableConversions: unacceptableConversionsReducer,
	streams: streamsReducer,
	ranks: ranksReducer,
	stream: streamReducer,
	globalPostback: globalPostbackReducer,
	userApi: userApiReducer,
	smartNotification: smartNotificationReducer,
	affiliates: affiliatesReducer,
	managerPopup: managerPopupReducer,
	bmAccounts: bmAccountsReducer,
	chainList: chainListReducer,
	survey: surveyReducer,
	manager: managerReducer
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/index.js